export enum ToggleDirection {
  UP = "up",
  DOWN = "down",
}
